import { Icon } from "../icon";
import styles from "./month-range-picker.module.scss";
import type { YearView } from "./types-month-range-picker";
import { MonthRangePickerMonth } from "./view-month";

/** Um ano: título, a seta de navegação (anterior no primeiro, próximo no segundo) e os 12 meses. */
export function MonthRangePickerYear({
  year,
  arrow,
  testId,
  arrowLabel,
  arrowIcon,
  arrowTestId,
  arrowDisabled,
  onArrow,
  months,
}: YearView) {
  const arrowButton = (
    <button
      type="button"
      className={styles.arrow}
      aria-label={arrowLabel}
      disabled={arrowDisabled}
      onClick={onArrow}
      data-testid={arrowTestId}
    >
      <Icon name={arrowIcon} size={14} />
    </button>
  );
  const spacer = <span className={styles.arrowSpacer} aria-hidden />;

  return (
    <section className={styles.year} aria-label={String(year)} data-testid={testId}>
      <header className={styles.yearHeader}>
        {arrow === "previous" ? arrowButton : spacer}
        <span className={styles.yearTitle}>{year}</span>
        {arrow === "next" ? arrowButton : spacer}
      </header>
      <div className={styles.months}>
        {months.map((month) => (
          <MonthRangePickerMonth key={month.monthKey} {...month} />
        ))}
      </div>
    </section>
  );
}
